import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '61px'
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'center'
  },

  button: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
